var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feedback-comment", class: _vm.classes, style: _vm.styles },
    [
      !_vm.isReply
        ? _c("div", [
            _c("p", { staticClass: "feedback-comment-title d-none" }, [
              _vm._v("\n      " + _vm._s(_vm.feedbackData.title) + "\n    ")
            ]),
            _vm._v(" "),
            _vm.feedbackData.feedbackRating.rating.ratingValue > 0
              ? _c(
                  "div",
                  { staticClass: "feedback-rating" },
                  _vm._l(5, function(i) {
                    return _c("i", {
                      key: "feedback_rating_" + i,
                      staticClass: "fa fa-star",
                      class: {
                        full:
                          _vm.feedbackData.feedbackRating.rating.ratingValue >=
                          i,
                        empty:
                          _vm.feedbackData.feedbackRating.rating.ratingValue < i
                      }
                    })
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "feedback-attributes-list" }, [
              _c(
                "p",
                _vm._l(_vm.variationAttributes, function(
                  variationAttribute,
                  index
                ) {
                  return _c(
                    "span",
                    {
                      key: "feedback_attributes_" + index,
                      staticClass: "feedback-attributes"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(variationAttribute.name) +
                          ": " +
                          _vm._s(variationAttribute.value) +
                          "\n        "
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", {
        staticClass: "feedback-comment-text",
        domProps: { textContent: _vm._s(_vm.message) }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "feedback-info" }, [
        _c("span", { staticClass: "feedback-info-segment" }, [
          _c("strong", [
            _vm.feedbackData.sourceRelation[0].feedbackRelationType === "user"
              ? _c(
                  "span",
                  {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    staticClass: "feedback-admin",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      "data-original-title": _vm.$translate(
                        "Feedback::Feedback.shopManagerLabel"
                      )
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-check-square" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.feedbackData.sourceRelation[0].sourceRelationLabel
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm.feedbackData.sourceRelation[0].feedbackRelationSourceId ==
                  0 && _vm.feedback.authorName.length > 0
              ? _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.feedbackData.authorName) +
                      "\n        "
                  )
                ])
              : _vm.feedbackData.sourceRelation[0].feedbackRelationSourceId == 0
              ? _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$translate("Feedback::Feedback.guestName")) +
                      "\n        "
                  )
                ])
              : _c("span", [
                  _vm._v(
                    "\n          " + _vm._s(_vm.displayName) + "\n        "
                  )
                ])
          ])
        ]),
        _vm._v(" "),
        _vm.options.timestampVisibility
          ? _c("span", { staticClass: "feedback-info-segment" }, [
              _c("i", { staticClass: "fa fa-calendar text-muted" }),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm._f("date")(
                      _vm.feedbackData.createdAt,
                      _vm.$translate("Ceres::Template.devDateFormatMoment") ||
                        "DD.MM.YYYY"
                    )
                  ) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !!_vm.feedbackData.replies &&
        _vm.feedbackData.replies.length > 0 &&
        !_vm.replyListVisible
          ? _c(
              "span",
              {
                staticClass: "feedback-info-segment btn btn-sm btn-default",
                on: {
                  click: function($event) {
                    _vm.replyListVisible = !_vm.replyListVisible
                  }
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$translate("Feedback::Feedback.viewComments")) +
                    " (" +
                    _vm._s(_vm.feedbackData.replies.length) +
                    ")\n    "
                )
              ]
            )
          : !!_vm.feedbackData.replies &&
            _vm.feedbackData.replies.length > 0 &&
            _vm.replyListVisible
          ? _c(
              "span",
              {
                staticClass: "feedback-info-segment btn btn-sm btn-default",
                on: {
                  click: function($event) {
                    _vm.replyListVisible = !_vm.replyListVisible
                  }
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$translate("Feedback::Feedback.hideComments")) +
                    "\n    "
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.replyFormVisible &&
      !_vm.isReply &&
      (_vm.authenticatedUser.isLoggedIn || _vm.options.allowGuestFeedbacks)
        ? _c("div", { staticClass: "feedback-add-reply" }, [
            !_vm.authenticatedUser.isLoggedIn && _vm.options.allowGuestFeedbacks
              ? _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.authorName,
                        expression: "authorName"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "author",
                      type: "text",
                      name: "author",
                      placeholder: _vm.$translate(
                        "Feedback::Feedback.authorName"
                      ),
                      disabled:
                        _vm.authenticatedUser.limitReached ||
                        !_vm.authenticatedUser.hasPurchased
                    },
                    domProps: { value: _vm.authorName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.authorName = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.honeypot,
                        expression: "honeypot"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "comment-textfield",
                      type: "text",
                      name: "comment-textfield"
                    },
                    domProps: { value: _vm.honeypot },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.honeypot = $event.target.value
                      }
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.replyMessage,
                    expression: "replyMessage"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  name: "message",
                  rows: "3",
                  placeholder: _vm.$translate(
                    "Feedback::Feedback.commentMessage"
                  )
                },
                domProps: { value: _vm.replyMessage },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.replyMessage = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-appearance",
                attrs: { disabled: !_vm.replyMessage },
                on: {
                  click: function($event) {
                    return _vm.createReply()
                  }
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$translate("Feedback::Feedback.submitComment")) +
                    "\n    "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.feedbackData.replies &&
      _vm.feedbackData.replies.length > 0 &&
      _vm.replyListVisible
        ? _c(
            "div",
            { staticClass: "feedback-replies" },
            _vm._l(_vm.feedbackData.replies, function(reply) {
              return _c("feedback-list-entry", {
                key: reply.id,
                attrs: {
                  feedback: reply,
                  "is-reply": true,
                  "show-controls": _vm.showControls,
                  classes: _vm.classes,
                  styles: _vm.styles,
                  options: _vm.options
                },
                on: {
                  delete: function($event) {
                    return _vm.$emit("delete", $event)
                  }
                }
              })
            }),
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }